// The cart JSON string (CartResponse.data) used to come back PascalCase from
// some endpoints and camelCase from others because two serialisers disagreed
// on the backend. The API now writes camelCase everywhere, but a frontend
// deployed ahead of the API — or a cart stored before the fix — can still hand
// us the PascalCase spelling. Resolve either, preferring camelCase.
export const readCartField = (cartData, camelName) => {
    if (!cartData || typeof cartData !== 'object' || !camelName) {
        return undefined;
    }
    if (cartData[camelName] !== undefined) {
        return cartData[camelName];
    }
    const pascalName = camelName.charAt(0).toUpperCase() + camelName.slice(1);
    return cartData[pascalName];
};

export const readCartTotalPrice = (cartData) => readCartField(cartData, 'totalPrice');
